import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CallsReportFilterForm } from 'src/app/shared/interfaces';

import { DataWithPagination } from '../../interface';
import { CallsReportApi } from '../api/calls-report-api';
import { CallReport } from '../model/call-report-model';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class CallsReportRepository extends Repository {
  constructor(private callsReportApi: CallsReportApi) {
    super();
  }

  getCallsReport(filter: CallsReportFilterForm): Observable<DataWithPagination<CallReport[]>> {
    return this.callsReportApi.getCallsReport(filter);
  }
}
